export const MM_NEWS_VIDEO_URL = 'https://www.moomoo.com/news/main/video-list';
export const NN_NEWS_VIDEO_URL = 'https://news.futunn.com/main/video-list';
